import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/auto-draft')({
    component: AutoDraftRedirect,
});

// Auto draft moved into the consolidated Scheduling page.
function AutoDraftRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
